import { render, staticRenderFns } from "./hijackingHelp.vue?vue&type=template&id=476d144a&scoped=true&"
import script from "./hijackingHelp.vue?vue&type=script&lang=js&"
export * from "./hijackingHelp.vue?vue&type=script&lang=js&"
import style0 from "./hijackingHelp.vue?vue&type=style&index=0&id=476d144a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476d144a",
  null
  
)

export default component.exports